import React, { useRef, Suspense } from "react";
import { Outlet, useOutletContext } from "react-router-dom";
import Footer from "../../../pages/Footer";
import Navbar from "../Navbar";
import { Container } from "../../atoms";

const Layout = () => {
  const footerRef = useRef(null);
  return (
    <>
      <Navbar context={{ footerRef }} />
      <Container className="overflow-x-hidden md:overflow-x-hidden">
        <Suspense fallback={<div className="min-h-screen bg-white" />}>
          <Outlet context={{ footerRef }} />
        </Suspense>
      </Container>
      <Footer ref={footerRef} />
    </>
  );
};

export default Layout;

export function useFooterRef() {
  return useOutletContext<{ footerRef: React.RefObject<HTMLDivElement> }>();
}
